<section class="section how-it-works-wrapper" *ngIf="_howItWorksData">
  <img class="ripple-img" src="/assets/images/ripple-bg.svg" />
  <div class="section-container align-c">
    <span class="product-hero-subheading mar-b-16 align-c">
      {{ _howItWorksData.tags?.[0]?.fields?.tagText }}
    </span>
    <h2 class="section-heading mar-b-64 wid-75 align-c">
      {{ _howItWorksData.title }}
    </h2>
    <div class="section-tailored-needs-container" [class.col-5]="columns === 5" [class.col-3]="columns === 3">
      <div
        class="section-tailored-needs"
        *ngFor="let card of _howItWorksData?.component1; let ind = index"
      >
        <div class="no-ico">{{ ind + 1 }}</div>
        <div class="mediakit">
          <h3 class="efficient-payment-heading">{{ card?.fields?.title }}</h3>
          <div
            class="efficient-payment-description"
            [innerHtml]="card?.fields?.description | toHtml"
          ></div>
        </div>
      </div>
    </div>
  </div>
</section>
